module.exports = __webpack_public_path__ + "img/active-telematics-floor-plan.b520b4f0.png";